import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import DefaultLoader from "components/common/DefaultLoader";
import * as labels from "config.labels";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as pricingActions from "store/actions/pricing/pricingActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as pricingSelectors from "store/selectors/pricing/pricingSelectors";

const LOADING_KEY = "__LOADING__";
const NONE_KEY = "__NONE__";

const ProcurementSelector = ({ disabled }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const { data: config, isLoading } = staticDataService.useConfigQuery(
    "procurement"
  );

  const dispatch = useDispatch();

  const layer = useSelector(pricingSelectors.selectResolvedActiveLayer);

  return (
    <FormControl variant={"filled"} fullWidth>
      <InputLabel className={"input-label"}>
        {translateLabel(labels.PROCUREMENT_LABEL, {
          default: "Procurement",
        })}
      </InputLabel>
      <Select
        value={layer?.procurement || NONE_KEY}
        onChange={(event) => {
          dispatch(
            pricingActions.updateLayer({
              layerId: layer.id,
              values: {
                procurement: event?.target?.value || NONE_KEY,
              },
            })
          );
        }}
        disabled={disabled}
        fullWidth
      >
        {isLoading && (
          <MenuItem value={LOADING_KEY}>
            <DefaultLoader
              size={16}
              style={{
                display: "block",
                textAlign: "center",
              }}
            />
          </MenuItem>
        )}
        <MenuItem value={NONE_KEY}>
          {translateLabel(labels.PROCUREMENT_NONE_OPTION, {
            default: "",
          })}
        </MenuItem>
        {(config?.active ?? []).map(({ key, name }) => (
          <MenuItem key={key} value={key}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProcurementSelector;
